const dividerStyle = {
    marginBottom:'10px',
    borderBottom: '1px solid #e2e1e1'
}

export function Divider(props) {
  return (
    <div style={{...dividerStyle, ...props.style}}/>
  );
}